webpackJsonp([22753727138929],{

/***/ 977:
/***/ (function(module, exports) {

	module.exports = {"data":{"contributionsJson":{"name":"uk summer '07","www_url":"http://www.napoli.com","thema":"SOS","issue_month":"October","issue_year":2007,"issue_date":200710,"artist":"organicmafia","location":"Italien","email":"chatula76@hotmail.com","id":"contribution_325","media_type":"still_image","position_in_section":3,"media_uri":"media/2007/October/still_image/uk summer.jpg","media_th_uri":"media/2007/October/still_image/tn_uk summer.jpg","still_image_count":4,"moving_image_count":1,"textz_count":1,"soundz_count":0}},"pathContext":{"id":"contribution_325"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200710-still-image-3-d5f4ff99201d9d55c38b.js